module.exports = __webpack_public_path__ + "static/media/rem-logo.759e1149.png";